export default __webpack_public_path__ + "static/media/criarpastainput.d2fb0790.svg";